import { html } from 'onefold';
import { CodeBlock } from '../../components/CodeBlock';
import { Callout } from '../../components/Callout';

export function VercelPage(): Node {
  return html`
    <div>
      <h1>Deploy to Vercel</h1>
      <p>Vercel supports SPA fallback out of the box. Use the default <strong>path-based routing</strong> — no <code>configureRouter</code> call needed.</p>

      <h2>Quick Deploy</h2>
      <ol>
        <li>Push your project to GitHub/GitLab/Bitbucket</li>
        <li>Go to <a href="https://vercel.com/new" target="_blank">vercel.com/new</a> and import the repo</li>
        <li>Set the build command and output directory:</li>
      </ol>

      <table>
        <tr><th>Setting</th><th>Value</th></tr>
        <tr><td>Build Command</td><td><code>npm run build</code></td></tr>
        <tr><td>Output Directory</td><td><code>dist</code></td></tr>
        <tr><td>Install Command</td><td><code>npm install</code></td></tr>
      </table>

      <h2>SPA Fallback Configuration</h2>
      <p>Create a <code>vercel.json</code> at the project root to explicitly configure the SPA rewrite:</p>
      ${CodeBlock(`{
  "buildCommand": "npm run build",
  "outputDirectory": "dist",
  "rewrites": [
    { "source": "/(.*)", "destination": "/index.html" }
  ]
}`, 'json')}

      ${Callout('The rewrites rule ensures all paths serve index.html, allowing the client-side router to handle them.')}

      <h2>Router Configuration</h2>
      <p>No special configuration needed — path mode is the default:</p>
      ${CodeBlock(`import { Router, mount } from 'onefold';

// Path-based routing works out of the box on Vercel
const app = Router([
  { path: '/', view: () => Home() },
  { path: '/about', view: () => About() },
], () => NotFound());

mount(app, document.getElementById('app')!);`)}

      <h2>Environment Variables</h2>
      <p>Set environment variables in Vercel's dashboard under Project Settings → Environment Variables. Access them at build time via your bundler's <code>define</code> option:</p>
      ${CodeBlock(`// build.mjs (esbuild)
await build({
  define: {
    'process.env.API_URL': JSON.stringify(process.env.API_URL || ''),
  },
});`)}

      <h2>Deploy via CLI</h2>
      ${CodeBlock(`# Install Vercel CLI
npm i -g vercel

# Deploy from project root
vercel

# Deploy to production
vercel --prod`, 'bash')}

      <h2>Next Steps</h2>
      <ul>
        <li><a href="/deployment/netlify">Netlify</a> — similar platform with _redirects file</li>
        <li><a href="/deployment/cloudflare">Cloudflare Pages</a> — edge deployment</li>
      </ul>
    </div>
  `;
}
